// Module
var code = "<div class=row ng-repeat=\"reasonReading in data\"> <div class=col-xs-12> <h3 translate>{{reasonReading.message}}</h3> <nlg-health-checker-history-graph reason=reasonReading></nlg-health-checker-history-graph> </div> </div> ";
// Exports
module.exports = code;